module.exports = __webpack_public_path__ + "img/button_checkin.b296cddd.png";